/* eslint-disable camelcase */
import { type UseMutationResult, useMutation } from 'react-query';

import { CustomReportsService } from '../../services/wealthlane-report-services';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import _ from 'lodash';
import { axiosInstance } from '../../services/apiInterceptor';

const transformPayload = (payload: Record<string, any>) => {
  const newPayload = {
    ...payload,
    requiredFieldBuckets: payload.requiredFieldBuckets?.map((item: any) => ({
      ...item,
      userFieldFormats: item?.userFieldFormats?.map((format: any) => ({
        key: format.key,
        value: !_.isEmpty(format.value) ? format.value : format.placeholder,
        placeholder: format.placeholder,
      })),
    })),
    optionalFieldBuckets: payload.optionalFieldBuckets?.map((item: any) => ({
      ...item,
      userFieldFormats: item?.userFieldFormats?.map((format: any) => ({
        key: format.key,
        value: !_.isEmpty(format.value) ? format.value : format.placeholder,
        placeholder: format.placeholder,
      })),
    })),
  };
  return newPayload;
};

const usePostExportCustomReportJsonFromJson = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<any | undefined, unknown, any, unknown> => {
  return useMutation(
    async (payload: any) => {
      let newPayload = { ...payload, reportConfigurationId: payload.id };
      newPayload = transformPayload(newPayload);

      // Use axiosInstance directly to get the raw Blob, bypassing OpenAPI's JSON parser
      // This ensures the file is exactly byte-for-byte what the backend sent
      const response = await axiosInstance.post(
        '/api/report/api/app/custom-reports/export-custom-report-json-from-json',
        newPayload,
        { responseType: 'blob' }
      );

      return { blob: response.data, variables: payload };
    },
    {
      onSuccess: async (data: any) => {
        if (data?.blob) {
          const { blob, variables } = data;
          let fileName = variables?.reportName ? `${variables.reportName}.wrc` : 'custom-report.wrc';

          // try {
          //   // Read the blob text just to extract the filename generated by the backend
          //   const text = await blob.text();
          //   const parsed = JSON.parse(text);
          //   if (parsed?.ReportName) {
          //     fileName = `${parsed.ReportName}.wrc`;
          //   } else if (parsed?.reportName) {
          //     fileName = `${parsed.reportName}.wrc`;
          //   }
          // } catch (e) {
          //   console.warn('Could not parse blob as JSON to extract ReportName', e);
          // }
          // Recreate the Blob without a type (strips 'application/json') 
          // This perfectly mimics useBlobDownload: new Blob([response.data])
          // and forces the browser to upload it as 'application/octet-stream' or empty type,
          // which the backend validation expects.
          const strippedBlob = new Blob([blob]);
          const blobUrl = window.URL.createObjectURL(strippedBlob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);

          toast.success(
            <ToastComponent label='Success' message='Report configuration exported successfully.' />
          );
        }
      },
      onError: (err: any) => {
        const message = err?.response?.data?.error?.message || 'Failed to export report configuration.';
        toast.error(<ToastComponent label='Error' message={message} />, {
          autoClose: 30000,
        });
      },
    }
  );
};

export default usePostExportCustomReportJsonFromJson;
